import { NSARouterMakerResult, NSAHomePage } from "namirasoft-account-react";
import { EmailSenderLayout } from "../EmailSenderLayout";
import { EmailSenderRouterProps } from "../EmailSenderRouterProps";

export interface HomePageProps extends NSARouterMakerResult, EmailSenderRouterProps { }

export default function HomePage(props: HomePageProps)
{
	return (
		<EmailSenderLayout
			{...props}
		>
			<NSAHomePage
				{...props}
			/>
		</EmailSenderLayout>
	);
}